// extracted by mini-css-extract-plugin
export var item = "Tags-module--item--2JSXQ";
export var link = "Tags-module--link--hkiai";
export var list = "Tags-module--list--3a6Ka";
export var tags = "Tags-module--tags--1r6Jk";